export var TemplateId;
(function (TemplateId) {
    TemplateId["BEXHeader"] = "BEXHeader";
    TemplateId["TemplateA"] = "Template-A";
    TemplateId["TemplateB"] = "Template-B";
    TemplateId["TemplateC"] = "Template-C";
    TemplateId["TemplateBlank"] = "Template-Blank";
})(TemplateId || (TemplateId = {}));
//# sourceMappingURL=common.js.map